import { useEffect, useRef } from 'react';
import { Button as BootstrapButton } from 'react-bootstrap';

import Icon from '../../../components/icon/Icon';
import MapOverlayShell from '../MapOverlayShell';

export const AUTO_DISMISS_MS = 8000;

export const formatVersionCreatedMessage = (actorName: string) =>
  `${actorName} created a new map version. You'll be moved to the latest version.`;

const Alert = ({
  message,
  onDismiss,
}: {
  message: string;
  onDismiss: () => void;
}) => (
  <div className='realtime-info-banner__alert position-relative'>
    <Icon icon='info-filled' className='mr-0' />
    <span className='font-14 font-weight--600'>{message}</span>
    <div className='dismiss-button-container mr-3'>
      <BootstrapButton
        variant='light'
        className='icon-button bg-transparent'
        onClick={onDismiss}
        aria-label='Close'
      >
        <Icon icon='close' className='mr-0' />
      </BootstrapButton>
    </div>
  </div>
);

const RealtimeInfoBanner = ({
  message,
  onDismiss,
  autoDismiss = true,
  inline = false,
}: {
  message: string | null;
  onDismiss: () => void;
  autoDismiss?: boolean;
  inline?: boolean;
}) => {
  // Refed so a non-memoized onDismiss from the parent doesn't restart the timer.
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss;

  useEffect(() => {
    if (!message || !autoDismiss) return;
    const t = setTimeout(() => onDismissRef.current(), AUTO_DISMISS_MS);
    return () => clearTimeout(t);
  }, [message, autoDismiss]);

  if (!message) return null;

  return inline ? (
    <div className='realtime-info-banner realtime-info-banner--inline'>
      <Alert message={message} onDismiss={onDismiss} />
    </div>
  ) : (
    <MapOverlayShell className='realtime-info-banner'>
      <Alert message={message} onDismiss={onDismiss} />
    </MapOverlayShell>
  );
};

export default RealtimeInfoBanner;
